import { IMapControlParam } from '@/types/map'

declare const BMapGL: any;

declare const BMAP_ANCHOR_TOP_LEFT: any;
declare const BMAP_ANCHOR_BOTTOM_LEFT: any;
declare const BMAP_ANCHOR_TOP_RIGHT: any;
declare const BMAP_ANCHOR_BOTTOM_RIGHT: any;
declare const BMAP_UNIT_IMPERIAL: any;
declare const BMAP_UNIT_METRIC: any;

//地图比例尺控件
export class ScaleControlBD {
    private static instances: Map<string, any>;//一个BMap.Map对应一个Control
    private view: any;
    private control: any;//比例尺控件
    private visible: boolean;
    private anchor: string;//"top-left"\"top-right"\"bottom-left"\"bottom-right"
    private xoffset: number;
    private yoffset: number;
    private unit: string;// 公制：metric，英制：non-metric

    constructor(view: any) {
        this.view = view;
        this.visible = false;
        this.anchor = "bottom-left";
        this.xoffset = 0;
        this.yoffset = 0;
        this.unit = "metric";
        this.control = undefined;
    }

    public static getInstance(view: any): ScaleControlBD {
        let id = view.getContainer().id;
        if (!ScaleControlBD.instances) {
            ScaleControlBD.instances = new Map();
        }
        let instance = ScaleControlBD.instances.get(id);
        //若没有view对应的实例，则重新创建一个
        if (!instance) {
            instance = new ScaleControlBD(view);
            ScaleControlBD.instances.set(id, instance);
        }
        return instance;
    }

    public async set(params: IMapControlParam) {
        if (!this.view) {
            //地图未创建，直接返回
            return;
        }
        let isRemove: boolean = params.options?.remove || false;
        if (isRemove) {
            this._remove();
            return;
        }
        if (!this.control) {
            //为地图添加一个比例尺控件
            this.control = new BMapGL.ScaleControl();
            this.view.addControl(this.control);
        }
        this.visible = params.visible || false;
        await this._setVisible();
        this.anchor = params.anchor || "bottom-left";
        await this._setAnchor();
        this.unit = params.options?.unit || "metric";
        await this._setUnit();
        this.xoffset = params.options?.xoffset || 0;
        this.yoffset = params.options?.yoffset || 0;
        await this._setOffset();
    }

    //删除自身
    private async _remove() {
        if (!this.view) {
            return;
        }
        let id = this.view.getContainer().id;
        ScaleControlBD.instances.delete(id);
        this.view.removeControl(this.control);
        this.control = undefined;
        this.view == null;
    }

    //设置锚点
    private async _setAnchor() {
        let ca: string;
        switch (this.anchor) {
            case "top-left":
                ca = BMAP_ANCHOR_TOP_LEFT;
                break;
            case "top-right":
                ca = BMAP_ANCHOR_TOP_RIGHT;
                break;
            case "bottom-right":
                ca = BMAP_ANCHOR_BOTTOM_RIGHT;
                break;
            case "bottom-left":
            default:
                ca = BMAP_ANCHOR_BOTTOM_LEFT;
                break;
        }
        this.control.setAnchor(ca);
    }

    //设置比例尺单位制
    private async _setUnit() {
        let lu: string;
        switch (this.unit) {
            case "metric":
                lu = BMAP_UNIT_METRIC;
                break;
            case "non-metric":
                lu = BMAP_UNIT_IMPERIAL;
                break;
            default:
                lu = BMAP_UNIT_METRIC;
        }
        this.control.setUnit(lu);
    }

    //设置偏移
    private async _setOffset() {
        this.control.setOffset(new BMapGL.Size(this.xoffset, this.yoffset));
    }

    //设置是否可见
    private async _setVisible() {
        if (this.visible) {
            this.control.show();
        } else {
            this.control.hide();
        }
    }
};